import React from "react";
import { Modal, Box, Button } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 500,
  bgcolor: "background.paper",
  borderRadius: 8,
  boxShadow: 24,
  p: 3,
  textAlign: "center",
};

const ViewBannerModal = ({ open, banner, handleClose }) => {
  if (!open || !banner) return null;

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <div className="flex flex-col items-center space-y-4">
          <img
            src={banner.img}
            alt={banner.name}
            className="max-h-[70vh] w-auto rounded-2xl object-contain shadow-md"
          />
          <Button
            onClick={handleClose}
            variant="contained"
            sx={{
              mt: 2,
              backgroundColor: "#c51369",
              "&:hover": { backgroundColor: "#a10f5b" },
              width: "50%",
            }}
          >
            Close
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default ViewBannerModal;
